import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.json.parse.js";
import Vue from "vue";
import store from "../store/index";
// import { DesDecrypt, DesEncrypt } from "@/utils/cryptojs";

import { decrypt as DesDecrypt, encrypt as DesEncrypt } from "../common/js/common";
var DB_NAME = "WsInput";
var DB_VERSION = 1; //使用正整数，别用浮点型

export default class dbService {
  //初始化数据库，表
  static async initDb() {
    return new Promise(async (resolve, reject) => {
      console.debug("initDb ...");
      var req = indexedDB.open(DB_NAME, DB_VERSION);
      req.onsuccess = function (evt) {
        let db = evt.target.result;
        store.commit("modifyDb", db);
        console.log("initDb opened");
        resolve();
      };
      req.onerror = function (evt) {
        console.error("initDb error:", evt.target.errorCode || evt.target.error);
        reject();
      };

      //增加数据库版本号时,会触发onupgradeneeded事件(会在onsuccess之前被调用)
      req.onupgradeneeded = function (evt) {
        console.log("db onupgradeneeded");
        let db = evt.target.result;

        //ObjectStore必须在onupgradeneeded里创建，其他地方将会创建失败
        if (!db.objectStoreNames.contains("huashuList")) {
          //主键自增
          // { keyPath : "id",autoIncrement: true}
          //话术id
          var hushuStore = db.createObjectStore("huashuList", {
            keyPath: "id",
            unique: true
          });
          // //话术文本
          // hushuStore.createIndex("speechText", "speechText", {
          //   unique: false,
          // });
          // //标记颜色
          // hushuStore.createIndex("markerColor", "markerColor", {
          //   unique: false,
          // });
          // //发送是否携带标题：0不写道，1携带
          // hushuStore.createIndex("isCarryTitle", "isCarryTitle", {
          //   unique: false,
          // });
          // //编辑时间
          // hushuStore.createIndex("editTime", "editTime", {
          //   unique: false,
          // });
          // //标题
          // hushuStore.createIndex("title", "title", {
          //   unique: false,
          // });
          //话术分类id
          hushuStore.createIndex("labelId", "labelId", {
            unique: false
          });
          //话术id
          hushuStore.createIndex("speechId", "speechId", {
            unique: false
          });
        }

        //    if (!db.objectStoreNames.contains("groups")) {
        //      //主键自增
        //      // { keyPath : "id",autoIncrement: true}
        //      var friendsStore = db.createObjectStore("groups", {
        //        keyPath: "targetId",
        //      });
        //      friendsStore.createIndex("encodeData", "encodeData", {
        //        unique: false,
        //      });
        //    }

        //    if (!db.objectStoreNames.contains("groupMembers")) {
        //      var groupsStore = db.createObjectStore("groupMembers", {
        //        keyPath: "targetId",
        //      });
        //      // groupsStore.createIndex('endid', 'endid', { unique: false });
        //      groupsStore.createIndex("updateTime", "updateTime", {
        //        unique: false,
        //      });
        //      groupsStore.createIndex("encodeData", "encodeData", {
        //        unique: false,
        //      });
        //    }

        //    if (!db.objectStoreNames.contains("conversationStick")) {
        //      var conversationStickStore = db.createObjectStore(
        //        "conversationStick",
        //        { keyPath: "targetId" }
        //      );
        //      conversationStickStore.createIndex("updateTime", "updateTime", {
        //        unique: false,
        //      });
        //      conversationStickStore.createIndex("encodeData", "encodeData", {
        //        unique: false,
        //      });
        //    }
      };
    });
  }

  //清除数据
  static async clearAllData() {
    return new Promise(async (resolve, reject) => {
      try {
        await this.clearData("huashuList");
        resolve();
      } catch (err) {
        console.log("clearAllData err:", err);
      }
    });
  }

  //删除数据库
  static deleteDB() {
    return new Promise(async (resolve, reject) => {
      let req = indexedDB.deleteDatabase(DB_NAME);
      req.onerror = function (evt) {
        console.error("delete onerror ==" + evt.target.errorCode || evt.target.error);
      };
      req.onsuccess = function (evt) {
        console.log("delete db onsuccess");
        resolve();
      };
    });
  }

  //关闭数据库连接
  static closeDB() {
    let db = store.state.db;
    return new Promise(async (resolve, reject) => {
      db.close();
      resolve();
    });
  }

  //给表中添加、更新数据
  static addData(storeName, data, targetId) {
    let db = store.state.db;
    return new Promise(async (resolve, reject) => {
      let encodeDataList = [];
      for (let i = 0; i < data.length; i++) {
        data[i].speechId = targetId;
        encodeDataList.push(data[i]);
      }
      var request = db.transaction([storeName], "readwrite");
      var objStore = request.objectStore(storeName);
      var i = 0,
        len = encodeDataList.length;
      while (i < len) {
        await objStore.put(encodeDataList[i++]);
      }
      request.oncomplete = function (evt) {
        console.log("数据写入成功");
        resolve();
      };
      request.onerror = function (evt) {
        console.log("数据写入失败");
        console.error("addData error:", evt.target.errorCode || evt.target.error);
      };
    });
  }

  //表中删除数据
  static delData(storeName, data) {
    let db = store.state.db;
    return new Promise(async (resolve, reject) => {
      var request = db.transaction([storeName], "readwrite");
      var objStore = request.objectStore(storeName);
      var i = 0,
        len = data.length;
      while (i < len) {
        await objStore.delete(data[i++].id);
      }
      request.oncomplete = function (evt) {
        console.log("数据写入成功");
        resolve();
      };
      request.onerror = function (evt) {
        console.log("数据写入失败");
        console.error("addData error:", evt.target.errorCode || evt.target.error);
      };
    });
  }

  //根据键值获取解密数据
  static getDataListByIdx(storeName, key, value) {
    let db = store.state.db;
    return new Promise(async (resolve, reject) => {
      var tx = db.transaction(storeName);
      var usersStore = tx.objectStore(storeName);
      var request = usersStore.get(DesEncrypt(value));
      let list = [];
      request.onsuccess = function (evt) {
        //解密
        var result = evt.target.result;
        if (result) {
          let decryptResult = {
            list: JSON.parse(DesDecrypt(result.encodeData)),
            updateTime: result.updateTime,
            targetId: DesDecrypt(result.targetId)
          };
          resolve(decryptResult);
        } else {
          resolve(null);
        }
      };
      request.onerror = function (evt) {
        console.error("getData error:", evt.target.errorCode || evt.target.error);
        reject("getData error:" + evt.target.errorCode || evt.target.error);
      };
    });
  }

  //获取表的全部数据
  static getAllData(storeName) {
    return new Promise(async (resolve, reject) => {
      let db = store.state.db;
      const transaction = db.transaction(storeName, "readonly");
      const biao = transaction.objectStore(storeName);
      const results = [];
      const cursorRequest = biao.openCursor();
      cursorRequest.onsuccess = event => {
        const cursor = event.target.result;
        if (cursor) {
          const record = cursor.value;
          // if (
          //   record.speechText &&
          //   record.speechText.toLowerCase().includes(keyword)
          // ) {
          results.push(record);
          // }
          cursor.continue();
        } else {
          resolve(results);
        }
      };
      cursorRequest.onerror = event => {
        reject("Cursor error: " + event.target.error);
      };
    });
  }
  static search(keyword, storeName) {
    return new Promise((resolve, reject) => {
      let db = store.state.db;
      const transaction = db.transaction(storeName, "readonly");
      const biao = transaction.objectStore(storeName);
      const results = [];
      const cursorRequest = biao.openCursor();
      cursorRequest.onsuccess = event => {
        const cursor = event.target.result;
        if (cursor) {
          const record = cursor.value;
          if (record.speechText && record.speechText.toLowerCase().includes(keyword)) {
            results.push(record);
          }
          cursor.continue();
        } else {
          resolve(results);
        }
      };
      cursorRequest.onerror = event => {
        reject("Cursor error: " + event.target.error);
      };
    });
  }

  // static updateData(){
  //      var tx = db.transaction("users", READ_WRITE);
  //      var store = tx.objectStore("users");
  //      var req = store.put({
  //           id : '001',
  //           name : '刘亦菲-小龙女',
  //           age : 18
  //      });
  //      req.onsuccess = function (evt) {
  //           console.debug("updateData success");
  //      };
  //      req.onerror = function (evt) {
  //           console.error("updateData error:", evt.target.errorCode || evt.target.error);
  //      };
  // }

  // static delData(){
  //      var tx = db.transaction("users", READ_WRITE);
  //      var store = tx.objectStore("users");
  //      var req = store.delete("001");
  //      req.onsuccess = function (evt) {
  //           console.debug("delData success");
  //      };
  //      req.onerror = function (evt) {
  //           console.error("delData error:", evt.target.errorCode || evt.target.error);
  //      };
  // }

  //清空表
  static clearData(storeName) {
    let db = store.state.db;
    return new Promise(async (resolve, reject) => {
      if (db) {
        var tx = db.transaction(storeName, "readwrite");
        var store = tx.objectStore(storeName);
        var req = store.clear();
        req.onsuccess = function (evt) {
          resolve();
        };
        req.onerror = function (evt) {
          reject("clearData error:" + evt.target.errorCode || evt.target.error);
        };
      } else {
        resolve();
      }
    });
  }
}